module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Light-a9729d8761b90a362e1f1999910987e9.ttf";